import { signInWithPopup, GoogleAuthProvider, signOut, onAuthStateChanged, createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
import { auth } from '../firebase';

const googleProvider = new GoogleAuthProvider();

export const signInWithGoogle = async () => {
    try {
        if (window.self !== window.top) {
             return { user: null, error: 'Google Login is blocked inside this preview window for security. Please click "Share" at the top right, or open the app in a New Tab to login with Google.' };
        }
        const result = await signInWithPopup(auth, googleProvider);
        return { user: result.user, error: null };
    } catch (error: any) {
        console.error('Error signing in with Google:', error);
        return { user: null, error: error.message };
    }
};

export const signUpWithEmail = async (email: string, pass: string) => {
    try {
        const result = await createUserWithEmailAndPassword(auth, email, pass);
        return { user: result.user, error: null };
    } catch (error: any) {
        console.error('Error signing up with email:', error);
        let msg = error.message;
        if (error.code === 'auth/email-already-in-use') {
            msg = 'This email is already in use. Please try logging in instead.';
        } else if (error.code === 'auth/weak-password') {
            msg = 'The password is too weak. Please use at least 6 characters.';
        } else if (error.code === 'auth/invalid-email') {
            msg = 'The email address is invalid.';
        } else if (error.code === 'auth/operation-not-allowed') {
            msg = 'Email sign-up is currently disabled. Please use Google Login or contact support.';
        }
        return { user: null, error: msg };
    }
};

export const signInWithEmail = async (email: string, pass: string) => {
    try {
        const result = await signInWithEmailAndPassword(auth, email, pass);
        return { user: result.user, error: null };
    } catch (error: any) {
        console.error('Error signing in with email:', error);
        let msg = error.message;
        if (error.code === 'auth/user-not-found' || error.code === 'auth/wrong-password' || error.code === 'auth/invalid-credential') {
            msg = 'Invalid email or password. Please try again.';
        } else if (error.code === 'auth/user-disabled') {
            msg = 'This account has been disabled.';
        } else if (error.code === 'auth/too-many-requests') {
            msg = 'Too many failed attempts. Please try again later.';
        } else if (error.code === 'auth/operation-not-allowed') {
            msg = 'Email sign-in is currently disabled. Please use Google Login or contact support.';
        }
        return { user: null, error: msg };
    }
};

export const logOut = async () => {
    try {
        await signOut(auth);
        return { error: null };
    } catch (error: any) {
        console.error('Error signing out:', error);
        return { error: error.message };
    }
};

export const onUserChange = (callback: (user: any) => void) => {
    return onAuthStateChanged(auth, callback);
};
